{
  "verified": "2026-09-13",
  "url": "https://www.bls.gov/web/empsit/cpseea42.htm",
  "sha256": "2cab883857821ac99f10c9ca78597c8b4ed37bc2cf760d16d4e08a8b7575fd42",
  "rows": [
    {
      "group": "summary",
      "label": "Total, 16 years and over",
      "total": 155455,
      "teleworkers": 33633,
      "values": [
        21.6,
        11,
        10.6
      ]
    },
    {
      "group": "occupation",
      "label": "Management, professional, and related occupations",
      "total": 67777,
      "teleworkers": 24351,
      "values": [
        35.9,
        19,
        16.9
      ]
    },
    {
      "group": "occupation",
      "label": "Management, business, and financial operations occupations",
      "total": 30225,
      "teleworkers": 12609,
      "values": [
        41.7,
        21.9,
        19.8
      ]
    },
    {
      "group": "occupation",
      "label": "Management occupations",
      "total": 20447,
      "teleworkers": 7450,
      "values": [
        36.4,
        19.8,
        16.7
      ]
    },
    {
      "group": "occupation",
      "label": "Business and financial operations occupations",
      "total": 9778,
      "teleworkers": 5158,
      "values": [
        52.8,
        26.2,
        26.5
      ]
    },
    {
      "group": "occupation",
      "label": "Professional and related occupations",
      "total": 37552,
      "teleworkers": 11743,
      "values": [
        31.3,
        16.7,
        14.6
      ]
    },
    {
      "group": "occupation",
      "label": "Computer and mathematical occupations",
      "total": 6750,
      "teleworkers": 4102,
      "values": [
        60.8,
        25.8,
        34.9
      ]
    },
    {
      "group": "occupation",
      "label": "Architecture and engineering occupations",
      "total": 3594,
      "teleworkers": 1269,
      "values": [
        35.3,
        23.4,
        11.9
      ]
    },
    {
      "group": "occupation",
      "label": "Life, physical, and social science occupations",
      "total": 1802,
      "teleworkers": 636,
      "values": [
        35.3,
        21.9,
        13.4
      ]
    },
    {
      "group": "occupation",
      "label": "Community and social services occupations",
      "total": 2784,
      "teleworkers": 951,
      "values": [
        34.2,
        24,
        10.2
      ]
    },
    {
      "group": "occupation",
      "label": "Legal occupations",
      "total": 1666,
      "teleworkers": 914,
      "values": [
        54.8,
        32.9,
        21.9
      ]
    },
    {
      "group": "occupation",
      "label": "Education, training, and library occupations",
      "total": 7438,
      "teleworkers": 1134,
      "values": [
        15.3,
        8.2,
        7
      ]
    },
    {
      "group": "occupation",
      "label": "Arts, design, entertainment, sports, and media occupations",
      "total": 3195,
      "teleworkers": 1408,
      "values": [
        44.1,
        20.7,
        23.4
      ]
    },
    {
      "group": "occupation",
      "label": "Healthcare practitioners and technical occupations",
      "total": 10324,
      "teleworkers": 1328,
      "values": [
        12.9,
        7.7,
        5.2
      ]
    },
    {
      "group": "occupation",
      "label": "Service occupations",
      "total": 25633,
      "teleworkers": 1486,
      "values": [
        5.8,
        2.2,
        3.6
      ]
    },
    {
      "group": "occupation",
      "label": "Healthcare support occupations",
      "total": 5471,
      "teleworkers": 645,
      "values": [
        11.8,
        2.6,
        9.1
      ]
    },
    {
      "group": "occupation",
      "label": "Protective service occupations",
      "total": 3124,
      "teleworkers": 177,
      "values": [
        5.7,
        3.3,
        2.3
      ]
    },
    {
      "group": "occupation",
      "label": "Food preparation and serving related occupations",
      "total": 7776,
      "teleworkers": 104,
      "values": [
        1.3,
        0.9,
        0.5
      ]
    },
    {
      "group": "occupation",
      "label": "Building and grounds cleaning and maintenance occupations",
      "total": 5477,
      "teleworkers": 176,
      "values": [
        3.2,
        2,
        1.3
      ]
    },
    {
      "group": "occupation",
      "label": "Personal care and service occupations",
      "total": 3784,
      "teleworkers": 384,
      "values": [
        10.1,
        3.7,
        6.5
      ]
    },
    {
      "group": "occupation",
      "label": "Sales and office occupations",
      "total": 29319,
      "teleworkers": 6828,
      "values": [
        23.3,
        10.8,
        12.5
      ]
    },
    {
      "group": "occupation",
      "label": "Sales and related occupations",
      "total": 13696,
      "teleworkers": 3273,
      "values": [
        23.9,
        11.9,
        12
      ]
    },
    {
      "group": "occupation",
      "label": "Office and administrative support occupations",
      "total": 15623,
      "teleworkers": 3555,
      "values": [
        22.8,
        9.8,
        12.9
      ]
    },
    {
      "group": "occupation",
      "label": "Natural resources, construction, and maintenance occupations",
      "total": 13698,
      "teleworkers": 414,
      "values": [
        3,
        1.8,
        1.2
      ]
    },
    {
      "group": "occupation",
      "label": "Farming, fishing, and forestry occupations",
      "total": 1074,
      "teleworkers": 40,
      "values": [
        3.7,
        1.3,
        2.4
      ]
    },
    {
      "group": "occupation",
      "label": "Construction and extraction occupations",
      "total": 7889,
      "teleworkers": 169,
      "values": [
        2.1,
        1.5,
        0.6
      ]
    },
    {
      "group": "occupation",
      "label": "Installation, maintenance, and repair occupations",
      "total": 4735,
      "teleworkers": 205,
      "values": [
        4.3,
        2.4,
        1.9
      ]
    },
    {
      "group": "occupation",
      "label": "Production, transportation, and material moving occupations",
      "total": 19028,
      "teleworkers": 554,
      "values": [
        2.9,
        1.5,
        1.5
      ]
    },
    {
      "group": "occupation",
      "label": "Production occupations",
      "total": 7531,
      "teleworkers": 362,
      "values": [
        4.8,
        2.2,
        2.6
      ]
    },
    {
      "group": "occupation",
      "label": "Transportation and material moving occupations",
      "total": 11497,
      "teleworkers": 192,
      "values": [
        1.7,
        0.9,
        0.7
      ]
    },
    {
      "group": "industry",
      "label": "Agriculture and related industries",
      "total": 2425,
      "teleworkers": 323,
      "values": [
        13.3,
        3.3,
        10
      ]
    },
    {
      "group": "industry",
      "label": "Nonagricultural industries",
      "total": 153030,
      "teleworkers": 33310,
      "values": [
        21.8,
        11.1,
        10.6
      ]
    },
    {
      "group": "industry",
      "label": "Mining, quarrying, and oil and gas extraction",
      "total": 505,
      "teleworkers": 45,
      "values": [
        8.9,
        8.3,
        0.6
      ]
    },
    {
      "group": "industry",
      "label": "Construction",
      "total": 11441,
      "teleworkers": 1104,
      "values": [
        9.6,
        5.9,
        3.8
      ]
    },
    {
      "group": "industry",
      "label": "Manufacturing",
      "total": 14452,
      "teleworkers": 2741,
      "values": [
        19,
        11.5,
        7.5
      ]
    },
    {
      "group": "industry",
      "label": "Durable goods manufacturing",
      "total": 9653,
      "teleworkers": 1921,
      "values": [
        19.9,
        12,
        7.9
      ]
    },
    {
      "group": "industry",
      "label": "Nondurable goods manufacturing",
      "total": 4799,
      "teleworkers": 820,
      "values": [
        17.1,
        10.3,
        6.8
      ]
    },
    {
      "group": "industry",
      "label": "Wholesale and retail trade",
      "total": 19018,
      "teleworkers": 2403,
      "values": [
        12.6,
        6.6,
        6.1
      ]
    },
    {
      "group": "industry",
      "label": "Wholesale trade",
      "total": 2955,
      "teleworkers": 754,
      "values": [
        25.5,
        13.2,
        12.3
      ]
    },
    {
      "group": "industry",
      "label": "Retail trade",
      "total": 16064,
      "teleworkers": 1649,
      "values": [
        10.3,
        5.3,
        4.9
      ]
    },
    {
      "group": "industry",
      "label": "Transportation and utilities",
      "total": 9866,
      "teleworkers": 919,
      "values": [
        9.3,
        5.7,
        3.6
      ]
    },
    {
      "group": "industry",
      "label": "Transportation and warehousing",
      "total": 8425,
      "teleworkers": 605,
      "values": [
        7.2,
        4,
        3.2
      ]
    },
    {
      "group": "industry",
      "label": "Utilities",
      "total": 1442,
      "teleworkers": 314,
      "values": [
        21.8,
        15.6,
        6.2
      ]
    },
    {
      "group": "industry",
      "label": "Information",
      "total": 3114,
      "teleworkers": 1528,
      "values": [
        49.1,
        21.3,
        27.7
      ]
    },
    {
      "group": "industry",
      "label": "Financial activities",
      "total": 10695,
      "teleworkers": 5471,
      "values": [
        51.2,
        25.7,
        25.4
      ]
    },
    {
      "group": "industry",
      "label": "Finance and insurance",
      "total": 7642,
      "teleworkers": 4334,
      "values": [
        56.7,
        27.1,
        29.6
      ]
    },
    {
      "group": "industry",
      "label": "Real estate and rental and leasing",
      "total": 3052,
      "teleworkers": 1136,
      "values": [
        37.2,
        22.2,
        15
      ]
    },
    {
      "group": "industry",
      "label": "Professional and business services",
      "total": 20916,
      "teleworkers": 8945,
      "values": [
        42.8,
        18.1,
        24.6
      ]
    },
    {
      "group": "industry",
      "label": "Professional and technical services",
      "total": 13443,
      "teleworkers": 7668,
      "values": [
        57,
        23.5,
        33.5
      ]
    },
    {
      "group": "industry",
      "label": "Management, administrative, and waste services",
      "total": 7473,
      "teleworkers": 1277,
      "values": [
        17.1,
        8.4,
        8.6
      ]
    },
    {
      "group": "industry",
      "label": "Education and health services",
      "total": 34253,
      "teleworkers": 6093,
      "values": [
        17.8,
        9.8,
        8
      ]
    },
    {
      "group": "industry",
      "label": "Educational services",
      "total": 11362,
      "teleworkers": 2117,
      "values": [
        18.6,
        11.2,
        7.5
      ]
    },
    {
      "group": "industry",
      "label": "Health care and social assistance",
      "total": 22891,
      "teleworkers": 3976,
      "values": [
        17.4,
        9.1,
        8.3
      ]
    },
    {
      "group": "industry",
      "label": "Hospitals",
      "total": 8167,
      "teleworkers": 1230,
      "values": [
        15.1,
        7.5,
        7.5
      ]
    },
    {
      "group": "industry",
      "label": "Health services, except hospitals",
      "total": 11194,
      "teleworkers": 1976,
      "values": [
        17.7,
        8.9,
        8.7
      ]
    },
    {
      "group": "industry",
      "label": "Social assistance",
      "total": 3531,
      "teleworkers": 770,
      "values": [
        21.8,
        13.1,
        8.7
      ]
    },
    {
      "group": "industry",
      "label": "Leisure and hospitality",
      "total": 13359,
      "teleworkers": 892,
      "values": [
        6.7,
        3.6,
        3.1
      ]
    },
    {
      "group": "industry",
      "label": "Arts, entertainment, and recreation",
      "total": 3349,
      "teleworkers": 505,
      "values": [
        15.1,
        7.2,
        7.9
      ]
    },
    {
      "group": "industry",
      "label": "Accommodation and food services",
      "total": 10010,
      "teleworkers": 387,
      "values": [
        3.9,
        2.4,
        1.5
      ]
    },
    {
      "group": "industry",
      "label": "Other services",
      "total": 7573,
      "teleworkers": 1379,
      "values": [
        18.2,
        9.1,
        9.1
      ]
    },
    {
      "group": "industry",
      "label": "Other services, except private households",
      "total": 7085,
      "teleworkers": 1323,
      "values": [
        18.7,
        9.6,
        9
      ]
    },
    {
      "group": "industry",
      "label": "Private households",
      "total": 488,
      "teleworkers": 56,
      "values": [
        11.4,
        1,
        10.4
      ]
    },
    {
      "group": "industry",
      "label": "Public administration",
      "total": 7837,
      "teleworkers": 1791,
      "values": [
        22.9,
        14.7,
        8.2
      ]
    }
  ]
}
